import React from 'react'
import styled from 'styled-components'
import { SvgAttr } from '../SvgAttr/SvgAttr'

export const IconX = ({
  classes = '',
  styles,
  width = '40px',
  height = '40px',
  color = 'currentColor',
}) => {
  return (
    <Svg
      viewBox='0 0 72 72'
      xmlns='http://www.w3.org/2000/svg'
      version='1.1'
      className={classes}
      width={width}
      height={height}
      styles={styles}
    >
      <title>X</title>
      <Path
        color={color}
        d='M62.97,36.01c0,15.26-12.37,27.64-27.64,27.64S7.7,51.27,7.7,36.01s12.37-27.64,27.64-27.64,27.64,12.37,27.64,27.64ZM50.86,19.96h-2.95c-3.59,3.79-7.04,7.72-10.72,11.42-3.04-3.7-5.81-7.61-8.72-11.42h-10.1l13.03,17.73-13.08,14.29c.1.06.24.08.35.08.82.06,1.75-.03,2.57-.03l11.45-12.36c.19,0,1.66,1.88,1.89,2.16,2.64,3.33,5.06,6.84,7.67,10.2l8.8.03,1.27-.11-13.86-18.6,12.4-13.4Z'
      />
      <Path
        color={color}
        d='M27.4,22.2l20.38,27.35.05.19c-.14.2-3.84.07-4.36.11l-.16-.06-20.43-27.43c-.02-.07.03-.09.09-.12.3-.15,1.47-.05,1.89-.06.74-.02,1.52-.12,2.27-.06.1,0,.2,0,.28.07Z'
      />
    </Svg>
  )
}

const Svg = styled(SvgAttr)`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  ${(props) => props.styles}
`

const Path = styled.path`
  transition: all 0.2s ease-in-out;
  fill: ${(props) => props.color};
`
